export default __webpack_public_path__ + "static/media/15.ee9ab322.JPG";